import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { GetAllPages, GetPageById, GetPagesCategories } from "~/API/KH";
import type { ISuppliersFilters, KnowledgeHubCategoryView, PageDetailsView, PaginatedResponsePageView } from "~/Core/Models";
import type { QueryResult } from "~/Store/globals";

const KHStore = (_set, _get) => ({
  GetAllPages(filters: ISuppliersFilters): QueryResult<AxiosResponse<PaginatedResponsePageView>> {
    return useQuery({
      placeholderData: keepPreviousData,
      queryFn: () => GetAllPages(filters),
      queryKey: ["GetAllPages", filters],
    });
  },

  GetPageById(id: string): QueryResult<AxiosResponse<PageDetailsView>> {
    return useQuery({
      queryFn: () => GetPageById(id),
      queryKey: ["GetPageById", id],
    });
  },

  GetTicketsTypes(): QueryResult<AxiosResponse<KnowledgeHubCategoryView[]>> {
    return useQuery({
      placeholderData: keepPreviousData,
      queryFn: GetPagesCategories,
      queryKey: ["GetPagesCategories"],
    });
  },
});

export default KHStore;
